import React, { useState, useEffect } from 'react';
import { Modal, Spin, Typography, Button } from 'antd';

const { Text } = Typography;

const PdfPreviewModal = ({ visible, onClose, pdfData, title }) => {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [internalLoading, setInternalLoading] = useState(true);

  useEffect(() => {
    if (pdfData && visible) {
      setInternalLoading(true);
      const blob = new Blob([pdfData], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      setPdfUrl(url);
      
      return () => {
        URL.revokeObjectURL(url);
        setPdfUrl(null);
        setInternalLoading(true);
      };
    } else if (!visible) {
        if (pdfUrl) URL.revokeObjectURL(pdfUrl);
        setPdfUrl(null);
        setInternalLoading(true);
    }
  }, [pdfData, visible]);

  const handleIframeLoad = () => {
    setInternalLoading(false);
  };

  const handleIframeError = () => {
    setInternalLoading(false);
    // message.error("Failed to load PDF in preview. The file might be corrupted or inaccessible."); // Will be replaced by notification in parent
    onClose();
  };

  return (
    <Modal
      title={title || "PDF Preview"}
      open={visible}
      onCancel={onClose}
      width="90%"
      centered
      style={{ 
        maxWidth: '1200px',
        top: '20px'
      }}
      footer={null}
      destroyOnClose={true}
      maskClosable={false}
      zIndex={1002}
    >
      <div style={{ height: '80vh', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
        {internalLoading && (
          <Spin size="large" tip="Preparing PDF preview..." style={{ marginBottom: '20px' }} />
        )}
        {pdfUrl ? (
          <iframe 
            src={pdfUrl}
            style={{ 
              width: '100%', 
              height: '100%', 
              border: 'none', 
              display: internalLoading ? 'none' : 'block'
            }}
            title="PDF Preview"
            onLoad={handleIframeLoad}
            onError={handleIframeError}
          />
        ) : (
            !internalLoading && (
                <Text type="secondary">No PDF document to display.</Text>
            )
        )}
        <Button onClick={onClose} style={{ marginTop: '20px' }}>
            Close Preview
        </Button>
      </div>
    </Modal>
  );
};

export default PdfPreviewModal;